import { render, staticRenderFns } from "./RiskPdf.vue?vue&type=template&id=41c466e8&scoped=true&"
import script from "./RiskPdf.vue?vue&type=script&lang=js&"
export * from "./RiskPdf.vue?vue&type=script&lang=js&"
import style0 from "./RiskPdf.vue?vue&type=style&index=0&id=41c466e8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41c466e8",
  null
  
)

export default component.exports